import React from 'react';
import BiodiversityForm from '../BiodiversityForm';
import slug from 'constants/slug';
import { create } from 'api/biodiversityApi';
import Message from 'rc-message';
import PageLockHOC from 'hoc/pageLock';

@PageLockHOC(['biodiversity.write'])
export default class BiodiversityCreate extends React.Component {
  static propTypes = {};

  handleSubmit = async (values) => {
    this.setState({
      isLoading: true,
    });

    const res = await create(values);
    if (res.success) {
      Message.success({ content: 'Thành Công' });
      this.props.history.push(slug.BIODIVERSITY.DETAIL_WITH_ID + res.data._id);
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    return (
      <div>
        <BiodiversityForm handleSubmit={this.handleSubmit} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityCreate/index.js